// number
export function normalizeNumberQueryParameter(
  queryParameter?: string,
  fallback: number = 0,
) {
  const parsedParameter = Number.parseInt(queryParameter ?? '');
  return isNaN(parsedParameter) ? fallback : parsedParameter;
}

// bool
export function normalizeBoolQueryParameter(
  queryParameter?: string,
  fallback: boolean = false,
) {
  return queryParameter === 'true' ? true : fallback;
}

// string
export function normalizeStringQueryParameter(
  queryParameter?: string,
  fallback: string = '',
) {
  return queryParameter ?? fallback;
}
